import React from 'react';
import { Box } from '@mui/material';
import { Inventory2 } from '@mui/icons-material';
import PageHeader from '../components/common/PageHeader';
import ShelfInventoryViewer from '../components/inventory/ShelfInventoryViewer';

const InventoryShelfPage: React.FC = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pt: 2, pb: 3 }}>
      <PageHeader
        icon={<Inventory2 sx={{ color: '#DC5829', fontSize: '1.9rem' }} />}
        title="Shelf-wise Inventory Management"
        subtitle="Search and view detailed inventory information by SKU code"
      />
      <ShelfInventoryViewer />
    </Box>
  );
};

export default InventoryShelfPage;
